import { extendTheme } from '@chakra-ui/react'

import Accordion from './theme.Accordion'
import Button from './theme.Button'
import Container from './theme.Container'
import Drawer from './theme.Drawer'
import FormLabel from './theme.FormLabel'
import Input from './theme.Input'
import Modal from './theme.Modal'
import Select from './theme.Select'
import Spinner from './theme.Spinner'
import Switch from './theme.Switch'
import Tabs from './theme.Tabs'
import Textarea from './theme.Textarea'

const foundation = {
  colors: {
    gray: {
      50: 'rgb(250 250 250)',
      100: 'rgb(244 244 245)',
      200: 'rgb(228 228 231)',
      300: 'rgb(212 212 216)',
      400: 'rgb(161 161 170)',
      500: 'rgb(113 113 122)',
      600: 'rgb(82 82 91)',
      700: 'rgb(63 63 70)',
      800: 'rgb(39 39 42)',
      900: 'rgb(24 24 27)',
    },
    primary: {
      50: 'rgb(247 254 231)',
      100: 'rgb(236 252 203)',
      200: 'rgb(217 249 157)',
      300: 'rgb(190 242 100)',
      400: 'rgb(163 230 53)',
      500: 'rgb(132 204 22)',
      600: 'rgb(101 163 13)',
      700: 'rgb(77 124 15)',
      800: 'rgb(63 98 18)',
      900: 'rgb(54 83 20)',
    },
    secondary: 'hsl(190, 70%, 50%)',
  },
  fonts: {
    body: 'Montserrat, sans-serif',
    heading: 'Hedvig Letters Serif, serif',
    mono: 'Montserrat, monospace',
  },
}

export const ChakraTheme = extendTheme({
  ...foundation,
  components: {
    Accordion,
    Button,
    Container,
    Drawer,
    Input,
    FormLabel,
    Modal,
    Select,
    Spinner,
    Switch,
    Tabs,
    Textarea,
  },
})
